import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { CHANGE_PASSWORD, EDIT_PROFILE } from "./actionTypes"
import { profileSuccess, profileError, changePasswordSuccess, chnagePasswordError } from "./actions"

//Include Both Helper File with needed methods
import { changePassword as changePasswordApi } from "../../../helpers/auth_helper"
import { put as putApi } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"

// PUT /api/users/{id} — update own profile fields.
function* editProfile({ payload: { user } }) {
  try {
    const response = yield call(putApi, `${url.USER_BY_ID}/${user.id}`, {
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      email: user.email,
    })
    yield put(profileSuccess(response))
  } catch (error) {
    yield put(profileError(error))
  }
}


//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* changePassword({ payload: { data, history } }) {
  try {
    // POST /api/users/change-password { currentPassword, newPassword, confirmPassword }
    yield call(changePasswordApi, {
      currentPassword: data.currentPassword,
      newPassword: data.newPassword ?? data.password,
      confirmPassword: data.confirmPassword ?? data.confirm ?? data.newPassword ?? data.password,
    })
    yield put(changePasswordSuccess("Change password successful"))
  } catch (error) {
    yield put(chnagePasswordError(error?.response?.data?.message || error))
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePassword)
}

function* ProfileSaga() {
  yield all([fork(watchProfile), fork(watchChangePassword)])
}

export default ProfileSaga
